<template>
    <b-container fluid class="custom-header" :class="themeClass" :style="{ backgroundColor: bgColor, color: color}">
        <b-row>
            <b-col class="logo-header">
                <a href="/"><img :src="logoHeader.logo" alt=""></a>
            </b-col>
            <b-col class="navs">
                <b-nav justified align="center" pills>
                    <b-nav-item v-for="(nav, index) in navs" :key="index"
                                :active="index === activeIndex"
                                @click="handleClick({index, nav})">
                        <a :href="nav.href" onclick="return false">
                            <div class="nav-content-container">
                                {{nav.text}}
                            </div>
                        </a>
                    </b-nav-item>
                </b-nav>
            </b-col>
            <b-col class="language">
                <span class="lang cn" :class="{ active: languageIdentification === 'cn' }" @click="changeLang('cn')" v-show="!hide_en_cn_switch">
                    <a :href="cnHref">CN</a>
                </span>
                <span class="lang en" :class="{ active: languageIdentification === 'en' }" @click="changeLang('en')" v-show="!hide_en_cn_switch">
                    <a :href="enHref">EN</a>
                </span>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import {mapState, mapMutations} from 'vuex'
    export default {
        name: 'customHeader',
        data() {
            return {
                bgColor: 'transparent',
                color: '#000',
                language: [{label: '中文', code: 'cn'}, {label: 'English', code: 'en'}],
                currentLanguage: {label: '中文', code: 'cn'},
                languageTitle: '语言',
                languageIdentification: 'cn',
                cnHref: '',
                enHref: '',
            }
        },
        props: {
            logoHeader: {
                type: Object,
            },
            navs: {
                type: Array,
                required: true
            },
            activeIndex: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            ...mapState('common', {
                themeClass: state => state.theme,
                pageThemeClass: state => {
                    return state.pageTheme
                },
                hide_en_cn_switch: state =>  state.hide_en_cn_switch
            })
        },
        watch:{
            $route(to){
                this.cnHref = to.path + '?lang=cn'
                this.enHref = to.path + '?lang=en'
            }
        },
        methods: {
            ...mapMutations('common', {
                setTheme: 'SET_THEME'
            }),
            handleClick({index, nav}) {
                this.$emit('changeNav', {index, nav})
            },
            menu() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop
                if (this.scroll < 300) {
                    this.bgColor = 'rgba(255,255,255,' + this.scroll / 60 + ')'
                } else {
                    this.bgColor = 'rgba(255,255,255,1)'
                    this.color = 'rgba(0,0,0,1)'
                }

                if (this.scroll < 10) {
                    this.setTheme({
                        theme: this.pageThemeClass
                    })
                } else {
                    this.setTheme({
                        theme: 'dark'
                    })
                }
            },
            changeLang(lang) {
                this.languageIdentification = lang

                localStorage.setItem('lang', lang)
                location.reload()
            }
        },
        mounted() {
            window.addEventListener('scroll', this.menu)
        },
        created() {
            if (this.$route.query.lang) {
                localStorage.setItem('lang', this.$route.query.lang)
            }

            const lang = localStorage.getItem('lang') || 'cn'
            this.languageIdentification = lang
            this.cnHref = location.pathname + '?lang=cn'
            this.enHref = location.pathname + '?lang=en'
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/style/var";
    @header-padding-top: 35px;
    @header-logo-width: 150px;

    .logo-header {
        padding-top: @header-padding-top;
        line-height: 1;

        img {
            width: @header-logo-width;
        }
    }

    .en {
        .nav-content-container {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }

        .language {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;

            .cn, .en {
                font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
            }
        }
    }

    .light {
        .navs {
            min-width: 400px;

            .nav {
                flex-wrap: nowrap;
            }

            .nav-pills {
                .nav-link {
                    &.active {
                        background-color: transparent !important;
                    }
                }
            }

            .nav-link {
                padding: @header-padding-top .5rem .5rem .5rem;
                color: @primary-light-color;
                font-size: 14px;
                background: transparent !important;
                transition: color .3s;

                &.active {
                    background-color: transparent;

                    .nav-content-container {
                        color: #999;
                        //border-bottom: 1px solid @primary-light-color;

                        &::after {
                            transform: scaleX(0);
                        }
                    }
                }

                &:hover {
                    background-color: transparent;

                    .nav-content-container {
                        color: @primary-light-color;
                        &::after {
                            transform: scaleX(1);
                        }
                    }
                }

                .nav-content-container {
                    position: relative;
                    display: inline-block;
                    padding-bottom: .1rem;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                    color: @primary-light-color;
                    white-space: nowrap;

                    &::after {
                        position: absolute;
                        content: '';
                        display: block;
                        bottom: -5px;
                        left: 0;
                        width: 100%;
                        height: 1px;
                        background: @primary-light-color;
                        transform: scaleX(0);
                        transition: transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1);
                    }
                }
            }
        }

        .language {
            position: relative;
            margin-top: -4px;
            padding-top: @header-padding-top;
            text-align: right;
            color: @primary-light-color;
            cursor: pointer;
            line-height: 1;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;

            .lang {
                display: inline-block;
                line-height: 1;
                a {
                    color: @primary-light-color;
                }

                &:nth-child(2) {
                    padding-left: 20px;
                }

                &.active {
                    a {
                        color: #999;
                    }
                }

                &.cn, &.en {
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                }
            }
        }
    }

    .dark {
        .navs {
            min-width: 400px;

            .nav {
                flex-wrap: nowrap;
            }

            /deep/ .nav-link {
                padding: @header-padding-top .5rem .5rem .5rem;
                color: @primary-dark-color;
                font-size: 14px;
                transition: color .3s;

                &.active {
                    background-color: transparent;

                    .nav-content-container {
                        color: #666;
                        //border-bottom: 1px solid @primary-dark-color;

                        &::after {
                            transform: scaleX(0);
                        }
                    }
                }

                &:hover {
                    color: @primary-dark-color;
                    background-color: transparent;

                    .nav-content-container {
                        &::after {
                            transform: scaleX(1);
                        }
                    }
                }

                .nav-content-container {
                    position: relative;
                    display: inline-block;
                    padding-bottom: .1rem;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                    color: @primary-dark-color;
                    white-space: nowrap;

                    &::after {
                        position: absolute;
                        content: '';
                        display: block;
                        bottom: -5px;
                        left: 0;
                        width: 100%;
                        height: 1px;
                        background: @primary-dark-color;
                        transform: scaleX(0);
                        transition: transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1);
                    }
                }
            }
        }

        .language {
            position: relative;
            text-align: right;
            margin-top: -4px;
            padding-top: @header-padding-top;
            color: @primary-dark-color;
            cursor: pointer;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;

            .lang {
                display: inline-block;

                a {
                    color: @primary-dark-color;
                }

                &.active {
                    a {
                        color: #999 !important;
                    }
                }

                &:nth-child(2) {
                    padding-left: 20px;
                }

                &.cn, &.en {
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                }
            }
        }
    }
</style>
